import type { Engine } from 'mrml';

const MAX_ATTEMPTS = 3;

let engine: Engine | null = null;
let attempts = 1;

export const loadEngine = async (): Promise<Engine> => {
  if (engine) {
    return engine;
  }

  const mod = await import('mrml').catch(() => {
    attempts += 1;
    return null;
  });

  if (!mod) {
    if (attempts == MAX_ATTEMPTS) {
      attempts = 1;
      return Promise.reject(`Failed to load 'mrml' ${MAX_ATTEMPTS} times.`);
    }

    return loadEngine();
  }

  attempts = 1;
  engine = new mod.Engine();

  return engine;
};
